import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/Footer";
import symptomExplorerImage from "@/assets/symptom-explorer-board.jpg";

// Personality: Encyclopaedic, editorial — two-column reading layout, index.
const SymptomExplorerLanding = () => {
  const symptoms = [
    "Hot flashes", "Night sweats", "Brain fog", "Anxiety",
    "Mood changes", "Insomnia", "Joint pain", "Fatigue",
    "Vaginal dryness", "Heart palpitations", "Weight changes", "Hair thinning",
  ];
  return (
    <div className="min-h-screen bg-[hsl(30,20%,96%)]">
      <div className="container mx-auto px-6 py-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back home
        </Link>
      </div>

      <header className="container mx-auto px-6 pt-8 pb-12 border-b border-foreground/20">
        <span className="text-xs uppercase tracking-[0.3em] text-foreground/60">The Reference</span>
        <h1 className="mt-4 text-5xl md:text-7xl leading-[1.05]" style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}>
          Symptom Explorer
        </h1>
      </header>

      <section className="container mx-auto px-6 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img src={symptomExplorerImage} alt="Symptom board" className="w-full h-auto rounded-lg" />
        </div>
        <div className="lg:col-span-7 lg:columns-2 gap-10 text-foreground/75 leading-relaxed" style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: "1.15rem" }}>
          <p className="mb-5">
            Perimenopause and menopause don't arrive with a manual. Every symptom is a signal —
            some obvious, most bewildering. The Symptom Explorer is our attempt at the manual you
            wish you'd been handed.
          </p>
          <p className="mb-5">
            Each entry begins with what it actually feels like, then moves to what's happening
            physiologically, what the evidence says helps, and when it's worth escalating to a
            clinician.
          </p>
          <p>
            No fear-mongering. No downplaying. Just the clearest account we can write of what your
            body is doing, and what you can do about it.
          </p>
        </div>
      </section>

      {/* Index */}
      <section className="container mx-auto px-6 pb-24">
        <p className="text-xs uppercase tracking-[0.3em] text-primary mb-6">Index</p>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-8 gap-y-3">
          {symptoms.map((s) => {
            const slug = s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
            return (
              <Link
                key={s}
                to={`/symptom-explorer/${slug}`}
                className="group flex items-baseline gap-3 border-b border-foreground/15 pb-2 hover:border-primary transition-colors"
              >
                <span className="text-primary/60 text-xs tabular-nums">·</span>
                <span
                  className="text-lg text-foreground group-hover:text-primary transition-colors"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {s}
                </span>
              </Link>
            );
          })}
        </div>
      </section>

      <section className="container mx-auto px-6 pb-24 text-center">
        <Button asChild size="lg" className="px-10 py-6 text-lg">
          <Link to="/symptom-explorer"><BookOpen className="mr-2 h-5 w-5" /> Open the reference <ArrowRight className="ml-2 h-5 w-5" /></Link>
        </Button>
      </section>

      <Footer />
    </div>
  );
};
export default SymptomExplorerLanding;
